var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useAppInfo } from '../react.js';
export function AppIcon(_a) {
    var { style, size } = _a, rest = __rest(_a, ["style", "size"]);
    const app = useAppInfo();
    return (_jsx("img", Object.assign({ src: app.iconPath, style: Object.assign({ width: size !== null && size !== void 0 ? size : 4 * 12, height: size !== null && size !== void 0 ? size : 4 * 12 }, style), alt: app.name + ' icon' }, rest)));
}
//# sourceMappingURL=AppIcon.js.map